import { useFlag } from '@/feature/feature-flags'

const defaultPosition = { center: { lat: -30.069547984853443, lng: 24.27277106134315 }, zoom: 6.5 }

export const useMapDefaultPosition = (): { center: google.maps.LatLngLiteral; zoom: number } => {
  return useFlag('mapDefaultPosition', defaultPosition)
}
